import { Flex, SimpleGrid } from "@mantine/core";
import {
  IconChartBar,
  IconInfoCircle,
  IconTrophy,
  IconUsers,
} from "@tabler/icons-react";
import StatCard from "../Registrations/StatCard";
import { useGetGiveawayStats } from "../../api/giveaways";

function GiveawayOverview({ giveawayId }) {
  const { data, isPending } = useGetGiveawayStats(giveawayId);
  const {
    totalAttendees = 0,
    totalParticipants = 0,
    completedParticipants = 0,
    averageProgress = 0,
    totalSponsors = 0,
  } = data || {};

  const participationRate =
    totalAttendees > 0
      ? Number(((totalParticipants / totalAttendees) * 100).toFixed(1))
      : 0;

  const completion =
    totalParticipants > 0
      ? ((completedParticipants / totalParticipants) * 100).toFixed(1)
      : 0;

  const statCards = [
    {
      title: "Participation",
      icon: <IconUsers size={24} />,
      color: "blue",
      details: [
        { label: "Total Attendees", value: totalAttendees },
        { label: "Participants", value: totalParticipants, color: "blue" },
        {
          label: "Participation Rate",
          value: `${participationRate}%`,
          color: "blue",
        },
      ],
      tooltip: {
        text: "Participants are users who scanned at least one sponsor code",
        icon: <IconInfoCircle size={18} />,
      },
    },
    {
      title: "Completion",
      icon: <IconTrophy size={24} />,
      color: "green",
      details: [
        {
          label: "In Giveaway Pool",
          value: completedParticipants,
          color: "green",
        },
        {
          label: "Completion Rate",
          value: `${completion}%`,
          color: "green",
        },
      ],
      tooltip: {
        text: "Users in the giveaway pool have scanned all sponsor codes",
        icon: <IconInfoCircle size={18} />,
      },
    },
    {
      title: "Progress",
      icon: <IconChartBar size={24} />,
      color: "violet",
      details: [
        {
          label: "Average Progress",
          value: `${averageProgress.toFixed(1)}%`,
          color: "violet",
        },
        {
          label: "Avg Scans per User",
          value:
            totalParticipants > 0
              ? ((averageProgress / 100) * totalSponsors).toFixed(1)
              : 0,
          color: "violet",
        },
      ],
      tooltip: {
        text: "Average progress across all participants who scanned at least one code",
        icon: <IconInfoCircle size={18} />,
      },
    },
  ];

  if (isPending) {
    return (
      <Flex py="md" w="100%">
        <SimpleGrid cols={{ lg: 3, md: 2, sm: 1 }} spacing="lg" w="100%">
          {[0, 1, 2].map((index) => (
            <StatCard key={index} loading />
          ))}
        </SimpleGrid>
      </Flex>
    );
  }

  return (
    <Flex py="md" w="100%">
      <SimpleGrid cols={{ lg: 3, md: 2, sm: 1 }} spacing="lg" w="100%">
        {statCards.map((stat, index) => (
          <StatCard key={index} stat={stat} />
        ))}
      </SimpleGrid>
    </Flex>
  );
}

export default GiveawayOverview;
